import ApiConfig from '../config/api'
import BaseAction from './action.abstract'

export default class AgentAction extends BaseAction {
  syncAgentMachineAttribute(machineId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.machine_attribute_sync, 'post', {
      machine_id: machineId,
    })
  }

  bindMachine(machineId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.machine_bind, 'post', {
      machine_id: machineId,
    })
  }

  createInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.instance_create, 'post', {
      instance_id: instanceId,
    })
  }

  registerAgentInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.instance_register, 'post', {
      instance_id: instanceId,
    })
  }

  terminateAgentInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.instance_terminate, 'post', {
      instance_id: instanceId,
    })
  }

  removeAgentInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.instance_remove, 'post', {
      instance_id: instanceId,
    })
  }

  resumeAgentInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.instance_resume, 'post', {
      instance_id: instanceId,
    })
  }

  pauseAgentInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent.instance_pause, 'post', {
      instance_id: instanceId,
    })
  }

  callCreateInstance(instanceId: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.agent_call.agent_call_create, 'post', {
      instance_id: instanceId,
    })
  }

  fetchAgentInstanceInfo(instanceId: any): Promise<any> {
    return this.FetchSimpleData(ApiConfig.api.agent.instance_info, {
      instance_id: instanceId,
    })
  }
}

export const agentAction = new AgentAction()
